import { readFileAsText } from '../../file'

/**
 * @returns {Promise<string>} if there was a file
 * @returns {Promise<null>} if there was no file
 */
export const readFirstFileAsText = ([file]: File[]): Promise<string | null> => (file ? readFileAsText(file) : Promise.resolve(null))
